export const keshis = [{
        value: "胃肠外科",
        label: "胃肠外科"
    },
    {
        value: "胸外科",
        label: "胸外科"
    },
    {
        value: "泌尿外科",
        label: "泌尿外科"
    },
    {
        value: "肝胆外科",
        label: "肝胆外科"
    },

    {
        value: "头颈外科",
        label: "头颈外科"
    },
    {
        value: "肿瘤内科",
        label: "肿瘤内科"
    },
     {
         value: "肾内科",
         label: "肾内科"
     },
    {
        value: "妇科",
        label: "妇科"
    },
    {
        value: "放疗科",
        label: "放疗科"
    },
    {
        value: "儿科",
        label: "儿科"
    },

    {
        value: "耳鼻喉科",
        label: "耳鼻喉科"
    },
    {
        value: "眼科",
        label: "眼科"
    },
    {
        value: "皮肤科",
        label: "皮肤科"
    },
    {
        value: "精神科",
        label: "精神科"
    },

    {
        value: "康复科",
        label: "康复科"
    },
    {
        value: "急诊科",
        label: "急诊科"
    },
    {
        value: "麻醉科",
        label: "麻醉科"
    },
    {
        value: "放射科",
        label: "放射科"
    },
    {
        value: "检验科",
        label: "检验科"
    },
    {
        value: "中医科",
        label: "中医科"
    },
    {
        value: "营养科",
        label: "营养科"
    },
    {
        value: "老年科",
        label: "老年科"
    },
    {
        value: "运动医学科",
        label: "运动医学科"
    },
    {
        value: "疼痛科",
        label: "疼痛科"
    },
    {
        value: "内分泌科",
        label: "内分泌科"
    },
    {
        value: "心血管内科",
        label: "心血管内科"
    },
    {
        value: "呼吸内科",
        label: "呼吸内科"
    },
    {
        value: "消化内科",
        label: "消化内科"
    },
   
    {
        value: "神经内科",
        label: "神经内科"
    },
    {
        value: "风湿免疫科",
        label: "风湿免疫科"
    },
    {
        value: "血液科",
        label: "血液科"
    },
    {
        value: "感染科",
        label: "感染科"
    },

    {
        value: "骨科",
        label: "骨科"
    },
    {
        value: "神经外科",
        label: "神经外科"
    },
    {
        value: "整形外科",
        label: "整形外科"
    },
    {
        value: "口腔科",
        label: "口腔科"
    },

    {
        value: "产科",
        label: "产科"
    },

]